import React, { Component } from "react";
import DeletePaymentMethodLayout from "home/components/delete-payment-method-layout";
import { apiFetch } from "apiFetch";
import { toast } from "react-toastify";

let errorMessage = "An error occured, please try again later";
let successMessage = "Payment method successfully deleted";

class DeletePaymentMethod extends Component {
  deletePayment = (paymentId, planId) => {
    let url = `/api/payment_methods/${paymentId}/${planId}`;

    apiFetch(url, {method: "DELETE"})
      .then(() => {
        this.props.handleShow("DeletePaymentMethod", false);
        toast.success(successMessage);
        this.props.removePaymentMethod(paymentId);
      })
      .catch(() => {
        toast.error(errorMessage);
      })
  };

  render() {
    return (
      <DeletePaymentMethodLayout
        show={this.props.show || true}
        handleShow={this.props.handleShow}
        deletePayment={this.deletePayment}
        paymentMethod={this.props.paymentMethod}
        currentPlan={this.props.currentPlan}
      />
    );
  }
}

export default DeletePaymentMethod;



// WEBPACK FOOTER //
// ./src/home/containers/delete-payment-method.js